import React from 'react'
import { Link } from 'react-router-dom'
import logo from 'assets/images/logo-white.png'

type Props = {
  searchString?: string
}

/**
 * Classes are hosted on Commuvity, so we embed their storefront.
 * The storefront has its own bottom tab bar on mobile, so there we cover our
 * nav with a full screen overlay and give a slim bar to get back to the site.
 */
export const GroupClassesPage = (_props: Props) => (
  <div className='fixed inset-0 z-50 flex flex-col bg-ink lg:static lg:z-0 lg:h-[calc(100dvh-4rem)]'>
    <Link
      to='/'
      className='flex items-center flex-shrink-0 h-12 px-4 space-x-2 text-white lg:hidden'>
      <span aria-hidden='true'>&larr;</span>
      <img src={logo} alt='' className='w-7 h-7' />
      <span className='font-black tracking-tight'>STL Swing</span>
    </Link>
    <iframe
      title='STL Swing group classes'
      className='flex-grow w-full bg-white'
      src='https://commuvity.com/store/1/events'
    />
  </div>
)

export default GroupClassesPage
